<template>
  <div class="meeting-type">
        <div class="d-flex justify-content-between mb-3">
            <div class="room-title">
                会议需求
            </div>
            <el-button class=" addition" icon="el-icon-plus" size="mini" type="primary">新增日期
                <el-date-picker 
                v-model="addDate"
                type="dates" 
                value-format="timestamp"
                :editable="false"
                @change="submitPost"
                :clearable="false"
                class="addition-date"/>
            </el-button>
            <!-- <el-button  icon="el-icon-plus" type="primary" size="mini" @click="submitPost()">新增日期</el-button> -->
        </div>
        <div class="room-Type" v-if="meeting_need_arr.length>0">
            <!--房型标题-->
            <ul class="roomtypetitle" >
                <li  class="mr-2 w-20">开会日期</li>
                <li class="roomtypetitle-information w-80" :class="{'w-90':modify}">
                    <div v-for="(item,index) in modify?modifyroomtypetitle:roomtypetitle" :key="index" :style="{width:item.width}">
                        {{item.name}}
                    </div>
                </li>
            </ul>
            <div class="room-rnk">
                <div class="roomtypetitle mt-3 roomtypetitle-bottom" v-for="(data,rowIdx) in meeting_need_arr" :key="data.value">
                    <!--入住日期-->
                    <div  class="mr-2 w-20">
                        <el-date-picker 
                        v-model="data.date" 
                        type="date"
                        :editable="false"
                        :clearable="false" 
                        value-format="timestamp"
                        :picker-options="forbiddenStartTime(data,rowIdx)"   
                        @input="onFieldChange"
                        :class="{ roomRed: isFieldError(rowIdx, 'date') }"
                        placeholder="选择日期"/>
                    </div>
                    <div class="roomtypetitle-list w-80" :class="{'w-90':modify}">
                        <!--房间类型、间数、操作-->
                        <div  class="d-flex w-100">
                            <!--时间段-->
                            <el-select  
                                v-model="data.timeslot" 
                                placeholder="请选择"
                                @input="onFieldChange"
                                :class="{ roomRed: isFieldError(rowIdx, 'timeslot') }"
                                class="w-50" 
                                >
                                <el-option
                                v-for=" i in $GVAR.TimeSlots"
                                :key="i.id"
                                :label="i.name"
                                :disabled="selectTime(data,i,rowIdx)"
                                :value="i.id">
                                </el-option>
                            </el-select>
                            <!--布局-->
                            <el-select  
                                v-model="data.type" 
                                placeholder="请选择" 
                                @input="onFieldChange"
                                class="w-50 ml-2"
                                :class="{ roomRed: isFieldError(rowIdx, 'type') }"
                                >
                                <el-option
                                v-for=" i in $GVAR.LayoutTypes"
                                :disabled="selectType(data,i,rowIdx)"
                                :key="i.id"
                                :label="i.name"
                                :value="i.id">
                                </el-option>
                            </el-select>
                            <!--人数-->
                            <el-input 
                                type="number"  v-model.number="data.num" 
                                @mousewheel.native.prevent 
                                class="ml-2 w-50"
                                @input="onFieldChange" 
                                :class="{ roomRed: isFieldError(rowIdx, 'num') }"
                                placeholder="人数">
                                <span slot="append">人</span>
                            </el-input>
                            <!--要求面积-->
                            <el-input 
                                type="number"  v-model.number="data.area" 
                                @mousewheel.native.prevent 
                                class="ml-2 w-50"
                                @input="onFieldChange" 
                                :class="{ roomRed: isFieldError(rowIdx, 'area') }"
                                placeholder="面积">
                                <span slot="append">㎡</span>
                            </el-input>
                            <!--会议室-->
                            <el-select  
                                v-model="data.offer_title" 
                                placeholder="填写/选择"
                                @input="onFieldChange"
                                filterable
                                allow-create
                                default-first-option
                                @change="getId($event,rowIdx)"
                                @blur="blurs($event,rowIdx)" 
                                :class="{ roomRed: isFieldError(rowIdx, 'offer_title') }" 
                                class="w-50 ml-2"  v-if="modify">
                                <el-option
                                v-for="roomItem in StoreMeetList"
                                :key="roomItem.title"
                                :label="roomItem.title"
                                :value="`${roomItem.id},${roomItem.title}`"
                                >
                                </el-option>
                            </el-select>
                            <!--单价-->
                            <el-input 
                            v-model.number="data.offer_price" 
                            placeholder="金额" 
                            class=" ml-2 w-50"
                            @input="onFieldChange" 
                            :class="{ roomRed: isFieldError(rowIdx, 'offer_price') }" 
                            type="number" v-if="modify">
                                <!-- <span slot="prepend">&yen;</span> -->
                                <span slot="append" class="lisxn">元/晚</span>
                            </el-input>
                            <!--操作-->
                            <div class="w-30 deletes">
                                <el-tooltip class="item" effect="dark" content="克隆会议" placement="bottom">
                                    <i class="el-icon-money" @click="clone(data)"></i>
                                </el-tooltip>
                                <el-tooltip class="item " effect="dark" content="删除会议" placement="bottom">
                                    <i class="el-icon-delete" @click="splicse(rowIdx)"></i>
                                </el-tooltip>
                                <!-- <el-button  class="mt-1" type="danger" size="mini" @click="splicse(i,index)">删除</el-button> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--提示信息-->
        <div class="room-Type mt-3 prompt" v-else>
            <img src="/images/order/icon_25.png">
            <span>请新增会议日期</span>
        </div>
  </div>
</template>

<script>
import { mapState} from 'vuex'
export default {
  name: '',
  components: {},
  props: {
    meeting_need: {
      type: Array,
      default: () => []
    },
    modify: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
        addDate:'',                              //新增日期
        meeting_need_arr:[
            { date: '', timeslot: '', num: '',area:'', type: ''}
        ],
        meetObjfs:{ date: '', timeslot: '', num: '',area:'', type: ''},
        roomtypetitle:[
            {name:'时间段',width:'50%'},
            {name:'布局',width:'50%'},
            {name:'出席人数',width:'50%'},
            {name:'要求面积 ',width:'50%'},
            {name:'操作',width:'30%'},
        ],
        modifyroomtypetitle:[
            {name:'时间段',width:'50%'},
            {name:'布局',width:'50%'},
            {name:'出席人数',width:'50%'},
            {name:'要求面积 ',width:'50%'},
            {name:'会议室 ',width:'50%'},
            {name:'单价 ',width:'50%'},
            {name:'操作',width:'30%'},
        ],
         // 错误标记：精准记录 行+子项+字段名
        isSubmit:false,
        errorMap:{},
    };
  },
  computed: {
        ...mapState(['StoreMeetList']),
  },
  watch: {
    meeting_need: {
      handler(newVal) {
        this.meeting_need_arr = JSON.parse(JSON.stringify(newVal));
      },
      deep: true, // 开启深度监听
      immediate: true // 一进页面就执行一次
    },
  },
  created() {},
  mounted() {},
  methods: {
    //新增一个日期
    submitPost(e){
        if(e.length==0) return;
        e.forEach(item=>{
            let data = Object.assign({}, JSON.parse(JSON.stringify(this.meetObjfs)));
            data.date = item;
            this.meeting_need_arr.push(data);
        })
        this.addDate='';
    },
    //删除房型
    splicse(i){
        this.meeting_need_arr.splice(i,1)
    },
    //确认订单
    submitForm(){
        this.isSubmit = true;
        const valid = this.validateAll();
        if (!valid) {
            this.$message.error('请填写完整的会议需求信息');
            return false;
        }
        return {meeting_need:this.meeting_need_arr};
    },
    // 全局校验，逐个字段判断
    validateAll() {
    this.errorMap = {};
    let pass = true;

    // 直接遍历一维数组 meeting_need_arr
    this.meeting_need_arr.forEach((item, rowIdx) => {
        // 固定校验 5 个字段
        const fields = this.modify?['date', 'timeslot', 'num', 'area', 'type','offer_price','offer_title']:['date', 'timeslot', 'num', 'area', 'type'];

        fields.forEach(field => {
        const val = item[field];
        if (!val || String(val).trim() === '') {
            this.setFieldError(rowIdx, field);
            pass = false;
        }
        });
    });

    return pass;
    },

    // 记录错误字段：key 格式 rowIdx|field
    setFieldError(rowIdx, field) {
    const key = `${rowIdx}|${field}`;
    this.errorMap[key] = true;
    },

    // 输入时实时更新错误状态
    onFieldChange() {
        if (!this.isSubmit) return;
        this.validateAll();
    },

    // 判断单个字段是否标红
    isFieldError(rowIdx, field) {
        if (!this.isSubmit) return false;
        const key = `${rowIdx}|${field}`;
        return !!this.errorMap[key];
    },

    // 禁用日期的回调函数，根据当前对象组和禁用日期的索引判断是否禁用日期
    forbiddenStartTime(item,index) {
        return {
          // 在禁用日期的回调中使用index
          disabledDate: (date) => {
            let meetObj=[...this.meeting_need_arr];
            //删除当前对象组
            meetObj.splice(index, 1);
            //判断是否有重复时间-重复布局 
            const allIndexes = meetObj.reduce((acc, user, index) => {
              if (user.type === item.type&&user.timeslot === item.timeslot) {
                acc.push(meetObj[index]); // 符合条件则添加索引到数组
              }
              return acc;
            }, []); // 初始值为空数组
            //判断禁用值
            let  hasTarget = allIndexes.some(user => user.date === date.getTime());
            // ===== 新增：过期日期判断逻辑 =====
            let isPast = false;
            if (!this.modify) {
                const today = new Date();
                // 置零时分秒，只对比日期
                today.setHours(0, 0, 0, 0);
                const targetDay = new Date(date);
                targetDay.setHours(0, 0, 0, 0);
                // 选中日期 < 今天 → 禁用
                isPast = targetDay.getTime() < today.getTime();
            }
            return hasTarget||isPast;
          }
        }
    },
    //禁用选项相同日期时段不同布局
    selectType(item,type,index){
        let meetObj=[...this.meeting_need_arr]
        //删除当前对象组
        meetObj.splice(index, 1);
        //判断是否有重复时间-重复布局
        const allIndexes = meetObj.reduce((acc, user, index) => {
          if (user.date === item.date&&user.timeslot === item.timeslot) {
            acc.push(meetObj[index]); // 符合条件则添加索引到数组
          }
          return acc;
        }, []); // 初始值为空数组
        //判断禁用值
        let  hasTarget = allIndexes.some(user => user.type === type.id);
        return hasTarget;
    },
          //禁用选项相同日期布局不同时段
      selectTime(item,selectTime,index){
        let meetObj=[
          ...this.meeting_need_arr
        ]
        //删除当前对象组
        meetObj.splice(index, 1);
        //判断是否有重复时间-重复布局
        const allIndexes = meetObj.reduce((acc, user, index) => {
          if (user.date === item.date&&user.type === item.type) {
            acc.push(meetObj[index]); // 符合条件则添加索引到数组
          }
          return acc;
        }, []); // 初始值为空数组
        //判断禁用值
        let  hasTarget = allIndexes.some(user => user.timeslot === selectTime.id);
        return hasTarget;
      },
    //克隆会议
    clone(data){
        data = Object.assign({}, JSON.parse(JSON.stringify(data)));
        data.date='';

        this.meeting_need_arr.push(data);
    },
    // 会议室相关
    getId(val,i){
            let [id, name] = val.split(',');
            let room_offer={...this.meeting_need_arr[i],offer_id:id?id:'0',offer_title:name?name:id};
            this.meeting_need_arr.splice(i, 1, room_offer);
    },
    blurs(val,i){
        // 原有校验、提交逻辑放这里
         let room_offer=this.StoreMeetList.find(item=>item.title==val.target.value);
        if(val.target.value&&!room_offer&&val.target.value!=this.meeting_need_arr[i].offer_title){
            let room_offer={...this.meeting_need_arr[i],offer_id:'0',offer_title:val.target.value};
            this.meeting_need_arr.splice(i, 1, room_offer);
        }
    },
  }
};
</script>

<style lang="scss" scoped>
    .prompt{
        text-align: center;
        img{
            width: 80px;
            height: 80px;
            display: inline-block;
        }
        span{
            display: block;
            color: #999;
        }
    }
    .room-Type{
        background-color: #fff;
        box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
        width: 94%;
        padding: 2% 3%;
        border-radius: 6px;
    }
    .room-rnk{
        max-height: 600px;
        overflow-y: auto;
        scroll-behavior: smooth; 
    }
    .meeting-type{
        text-align: left;
    }
    .room-title{
        font-size: 18px;
        font-weight: bold;
        color: #333;
        position: relative;
        padding-left: 12px;
        &::after{
            content: '';
            position: absolute;
            left: 0;
            top: 4px;
            height: 20px;
            width: 4px;
            background-color: var(--smtc-color-primary);
            border-radius: 50px;
        }
    }
    .roomtypetitle{
        display: flex;
        width: 100%;
        >li{
            text-align: center;
        }
    }
    .roomtypetitle-information{
        width: 70%;
        display: flex;
        text-align: center;
    }
    .roomtypetitle-list{
        width: 70%;
        display: flex;
        text-align: center;
        flex-wrap: wrap;
    
    }
    .roomtypetitle-bottom{
        border-bottom: 1px #eee solid;
        padding-bottom: 14px;
    }
    .room-type-footer{
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }
    .deletes{
        text-align: center;
        display: flex;
        justify-content: center;
        margin-top: 10px;
        color: red;
        cursor: pointer;
    }
    .el-icon-money{
        color: var(--smtc-color-green);
    }
    .addition{
        position: relative;
        overflow: hidden;
        width: 100px;
    }
    .addition-date{
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        opacity: 0;
    }
    .el-icon-delete{
        margin-left: 10px;
    }
</style>
<style>
    .meeting-type .el-date-editor.el-input{
        width: 100%;
    }
    .meeting-type .el-input__inner{
        text-align: center;
    }
    .meeting-type.el-input-group__append,.meeting-type .el-input--suffix .el-input__inner ,.meeting-type .el-input__inner{
        font-size: 12px;
    }
    .roomRed .el-input__inner,
    .roomRed .el-date-editor .el-input__inner {
    border-color: #F56C6C !important;
    }
</style>